export const commonProps = {
  slice: {
    validator: function ({ slice_type: sliceType, data }) {
      return sliceType && data;
    },
  },
};
